import { render, staticRenderFns } from "./BlockPicker.vue?vue&type=template&id=8048e6f6&scoped=true"
import script from "./BlockPicker.vue?vue&type=script&lang=js"
export * from "./BlockPicker.vue?vue&type=script&lang=js"
import style0 from "./BlockPicker.vue?vue&type=style&index=0&id=8048e6f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8048e6f6",
  null
  
)

export default component.exports